import styled from 'styled-components';
import { darken } from 'polished';

import background from '../../../assets/home2.jpg';

export const Background = styled.div`
  width: 100%;
  height: 100%;
  background-image: url(${background});
  background-size: 100%;
`;

export const Wrapper = styled.div`
  height: 100%;
  opacity: 0.98;
  background: #029f74;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const Content = styled.div`
  width: 100%;
  height: 90%;
  max-width: 315px;
  text-align: center;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  img {
    width: 315px;
  }

  form {
    display: flex;
    flex-direction: column;
    margin-top: 30px;

    input {
      width: 315px;
      background: rgba(0, 0, 0, 0.1);
      border: 0;
      border-radius: 4px;
      height: 44px;
      padding: 0 15px;
      color: #fff;
      margin: 0 0 10px;

      &::placeholder {
        color: rgba(255, 255, 255, 1);
      }
    }

    span {
      color: #000;
      align-self: flex-start;
      margin: 0 0 10px;
      font-weight: bold;
      font-size: 12px;
    }

    button {
      margin: 5px 0 0;
      height: 44px;
      background: #017c5f;
      font-weight: bold;
      color: #fff;
      border: 0;
      border-radius: 4px;
      font-size: 16px;
      transition: background 0.2s;

      &:hover {
        background: ${darken(0.05, '#017c5f')};
      }
    }

    a {
      color: #fff;
      margin-top: 15px;
      font-size: 16px;
      opacity: 0.8;

      &:hover {
        opacity: 1;
      }
    }
  }
`;

export const Footer = styled.div`
  width: 100%;
  height: 10%;
  display: flex;
  align-items: center;
  justify-content: center;
  a {
    font-size: 16px;
    color: ${darken(0.05, '#017c5f')};
  }
`;
